import React, { forwardRef, PropsWithChildren } from 'react';
import cx from 'classnames';

import type { ClassNamePropType } from 'Internals/react-utils';

import './HeaderButton.css';

type HeaderButtonProps = PropsWithChildren<{
  className?: string;
  isToggler?: boolean;
  isToggled?: boolean;
  darkModeActive: boolean;
  testid?: string;
}>;

export const HeaderButton = forwardRef<HTMLDivElement, HeaderButtonProps>(
  ({ children, className, isToggler, isToggled, darkModeActive, testid }, ref) => {
    return (
      <div
        className={cx(
          darkModeActive ? 'header-button dark' : 'header-button',
          isToggler && 'header-button--toggler',
          isToggled && 'header-button--open',
          className
        )}
        ref={ref}
        data-testid={testid}
      >
        {children}
      </div>
    );
  }
);
